import React, { useMemo, useState  } from 'react';
import { ColumnDef } from '@tanstack/react-table';
import { Link } from 'react-router-dom'; // موجود بالفعل، وهو مطلوب
import { FaEdit, FaPlus, FaTrashAlt } from 'react-icons/fa'; // 1. استيراد أيقونة التعديل والإضافة
import Icon from '../../../components/common/Icon';
import { toast } from 'react-hot-toast'; 
import { useServerSideTable } from '../../../hooks/useServerSideTable';
import { getPagedTrainees, deleteTrainee  } from '../../../services/traineeService';
import { Trainee } from '../../../types/trainee';
import Table from '../../../components/common/Table';
import ConfirmDialog from '../../../components/common/ConfirmDialog';
// 2. استيراد ملفات التنسيق الصحيحة
import pageStyles from '../../Page.module.css'; // ملف تنسيق الصفحة العام
//import sharedStyles from '../../SharedPageStyles.module.css'; // ملف التنسيقات المشترك للأزرار
// 1. قم بإنشاء واجهة (interface) لوصف أنواع الخصائص
interface TableHeaderProps {
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
}

// 2. استخدم هذه الواجهة في تعريف المكون
const TableHeader: React.FC<TableHeaderProps> = ({ searchTerm, setSearchTerm }) => {
  return (
    <div style={{ marginBottom: '1rem', maxWidth: '400px' }}>
      <input
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="ابحث في الجدول..."
        style={{ width: '100%', padding: '0.8rem', borderRadius: '6px', border: '1px solid #ccc' }}
      />
    </div>
  );
};
const TraineesListPage: React.FC = () => {
     // 5. إضافة حالة لإدارة الحذف
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [traineeToDelete, setTraineeToDelete] = useState<Trainee | null>(null);

  // دالة لفتح مربع حوار التأكيد
  const openDeleteDialog = (trainee: Trainee) => {
    setTraineeToDelete(trainee);
    setIsDeleteDialogOpen(true);
  };

  // دالة لإغلاق مربع الحوار
  const closeDeleteDialog = () => {
    setTraineeToDelete(null);
    setIsDeleteDialogOpen(false);
  };

  // 6. دالة تنفيذ الحذف
  const handleDelete = () => {
    if (!traineeToDelete) return;

    const promise = deleteTrainee(traineeToDelete.id);

    toast.promise(promise, {
      loading: 'جاري حذف المتدرب...',
      success: () => {
        closeDeleteDialog();
        refreshData(); // 7. تحديث البيانات بعد الحذف
        return 'تم حذف المتدرب بنجاح!';
      },
      error: (err) => {
        closeDeleteDialog();
        return err.response?.data?.message || 'فشل في حذف المتدرب.';
      },
    });
  };
  const columns = useMemo<ColumnDef<Trainee>[]>(() => [
    {
      header: 'اسم المتدرب',
      accessorKey: 'name',
    },
    {
      header: 'البريد الإلكتروني',
      accessorFn: (row) => row.user?.email || 'N/A',
    },
    {
      header: 'رقم القيد',
      accessorKey: 'trainee_number',
    },
    {
      header: 'المحامي المشرف',
      accessorFn: (row) => row.lawyer?.name || 'غير معين',
    },
    {
      header: 'تاريخ البدء',
      accessorFn: (row) => new Date(row.start_date).toLocaleDateString('ar-EG'),
    },
    {
      header: 'الإجراءات',
      id: 'actions', // من الأفضل دائمًا إعطاء id لعمود الإجراءات
      cell: ({ row }) => {
        const trainee = row.original; // الحصول على بيانات الصف الكاملة
        
        // 3. تفعيل زر التعديل باستخدام Link
        return (
          <div className={pageStyles.actionButtons}>
            <Link 
              to={`/admin/trainees/edit/${trainee.id}`} 
              className={`${pageStyles.actionButton} ${pageStyles.edit}`}
              title="تعديل" // نص يظهر عند مرور الفأرة
            >
                <Icon as={FaEdit} style={pageStyles.icon} />
              
            </Link>
            {/* يمكنك إضافة زر الحذف هنا بنفس الطريقة في المستقبل */}
            <button
              onClick={() => openDeleteDialog(trainee)}
              className={`${pageStyles.actionButton} ${pageStyles.delete}`}
              title="حذف"
            >
              <Icon as={FaTrashAlt} style={pageStyles.icon} />
            </button>
          </div>
        );
      },
    },
  ], []);

  const {
    table,
    isLoading,
    Pagination,
    refreshData,
    searchTerm, 
    setSearchTerm,
  } = useServerSideTable<Trainee>({
    columns,
    fetchData: getPagedTrainees,
  });

  return (
    <div className={pageStyles.pageContainer}>
      <div className={pageStyles.pageHeader}> {/* 4. استخدام التنسيق المشترك للهيدر */}
        <h1>إدارة المتدربين</h1>
        
        {/* 5. إضافة زر "إضافة متدرب جديد" */}
        <Link to="/admin/trainees/add" className={pageStyles.addButton}>
          <Icon as={FaPlus} style={pageStyles.icon } />
          <span>إضافة متدرب</span>
        </Link>
      </div>

      <div className={pageStyles.pageContent}> {/* 6. تغليف المحتوى */}
       <TableHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        <Table<Trainee>
          table={table}
          isLoading={isLoading}
        />
        <Pagination />
      </div>
      <ConfirmDialog
        isOpen={isDeleteDialogOpen}
        title="تأكيد الحذف"
        message={`هل أنت متأكد من رغبتك في حذف المتدرب "${traineeToDelete?.name}"؟ لا يمكن التراجع عن هذا الإجراء.`}
        onConfirm={handleDelete}
        onCancel={closeDeleteDialog}
      />
    </div>
  );
};

export default TraineesListPage;
